import {
  EKinematicBlockType,
  type IAttributesKinematicBlocks
} from '@web/entities/kinematic/model/kinematic.type'
import svgAD from '@web/shared/assets/images/kinematic/ASD_KS.svg'
import svgADDark from '@web/shared/assets/images/kinematic/ASD_KS_dark.svg'
import svgBD from '@web/shared/assets/images/kinematic/BD_KS.svg'
import svgBDDark from '@web/shared/assets/images/kinematic/BD_KS_dark.svg'
import svgBF from '@web/shared/assets/images/kinematic/BF_KS.svg'
import svgBFDark from '@web/shared/assets/images/kinematic/BF_KS_dark.svg'
import svgBR from '@web/shared/assets/images/kinematic/BR_KS.svg'
import svgBRDark from '@web/shared/assets/images/kinematic/BR_KS_dark.svg'
import svgBS from '@web/shared/assets/images/kinematic/BS_KS.svg'
import svgBSDark from '@web/shared/assets/images/kinematic/BS_KS_dark.svg'
import svgCD from '@web/shared/assets/images/kinematic/CD_KS.svg'
import svgCDDark from '@web/shared/assets/images/kinematic/CD_KS_dark.svg'
import svgCN from '@web/shared/assets/images/kinematic/CN_KS.svg'
import svgCNDark from '@web/shared/assets/images/kinematic/CN_KS_dark.svg'
import svgCP from '@web/shared/assets/images/kinematic/CP_KS.svg'
import svgCPDark from '@web/shared/assets/images/kinematic/CP_KS_dark.svg'
import svgCW from '@web/shared/assets/images/kinematic/CW_KS.svg'
import svgCWDark from '@web/shared/assets/images/kinematic/CW_KS_dark.svg'
import svgDCG from '@web/shared/assets/images/kinematic/DCG_KS.svg'
import svgDCGDark from '@web/shared/assets/images/kinematic/DCG_KS_dark.svg'
import svgDCM from '@web/shared/assets/images/kinematic/DCM_KS.svg'
import svgDCMDark from '@web/shared/assets/images/kinematic/DCM_KS_dark.svg'
import svgGBD from '@web/shared/assets/images/kinematic/GBD_KS.svg'
import svgGBDDark from '@web/shared/assets/images/kinematic/GBD_KS_dark.svg'
import svgGBT from '@web/shared/assets/images/kinematic/GBT_KS.svg'
import svgGBTDark from '@web/shared/assets/images/kinematic/GBT_KS_dark.svg'
import svgGB from '@web/shared/assets/images/kinematic/GB_KS.svg'
import svgGBDark from '@web/shared/assets/images/kinematic/GB_KS_dark.svg'
import svgHD from '@web/shared/assets/images/kinematic/HD_KS.svg'
import svgHDDark from '@web/shared/assets/images/kinematic/HD_KS_dark.svg'
import svgPD from '@web/shared/assets/images/kinematic/PD_KS.svg'
import svgPDDark from '@web/shared/assets/images/kinematic/PD_KS_dark.svg'
import svgSD from '@web/shared/assets/images/kinematic/SD_KS.svg'
import svgSDDark from '@web/shared/assets/images/kinematic/SD_KS_dark.svg'
import svgSG from '@web/shared/assets/images/kinematic/SG_KS.svg'
import svgSGDark from '@web/shared/assets/images/kinematic/SG_KS_dark.svg'
import svgSH from '@web/shared/assets/images/kinematic/SH_KS.svg'
import svgSHDark from '@web/shared/assets/images/kinematic/SH_KS_dark.svg'
import svgTGB from '@web/shared/assets/images/kinematic/TGB_KS.svg'
import svgTGBDark from '@web/shared/assets/images/kinematic/TGB_KS_dark.svg'
import svgTN from '@web/shared/assets/images/kinematic/TN_KS.svg'
import svgTNDark from '@web/shared/assets/images/kinematic/TN_KS_dark.svg'
import svgTW from '@web/shared/assets/images/kinematic/TW_KS.svg'
import svgTWDark from '@web/shared/assets/images/kinematic/TW_KS_dark.svg'

export const attributesKinematicBlocks: IAttributesKinematicBlocks[] = [
  {
    type: EKinematicBlockType.BR,
    title: 'Подшипник Качения',
    iconSrc: svgBR,
    iconSrcDark: svgBRDark,
    width: 40,
    height: 80
  },
  {
    type: EKinematicBlockType.CP,
    title: 'Муфта',
    iconSrc: svgCP,
    iconSrcDark: svgCPDark,
    width: 40,
    height: 80
  },
  {
    type: EKinematicBlockType.SH,
    title: 'Вал',
    iconSrc: svgSH,
    iconSrcDark: svgSHDark,
    width: 40,
    height: 80
  },
  {
    type: EKinematicBlockType.BS,
    title: 'Подшипниковая опора скольжения',
    iconSrc: svgBS,
    iconSrcDark: svgBSDark,
    width: 40,
    height: 80
  },
  {
    type: EKinematicBlockType.BF,
    title: 'Подшипниковая опора жидкостного трения (ПЖТ)',
    iconSrc: svgBF,
    iconSrcDark: svgBFDark,
    width: 40,
    height: 80
  },
  {
    type: EKinematicBlockType.AD,
    title: 'Асинхронный двигатель',
    iconSrc: svgAD,
    iconSrcDark: svgADDark,
    width: 120,
    height: 80
  },
  {
    type: EKinematicBlockType.SD,
    title: 'Синхронный двигатель',
    iconSrc: svgSD,
    iconSrcDark: svgSDDark,
    width: 120,
    height: 80
  },
  {
    type: EKinematicBlockType.SG,
    title: 'Синхронный генератор',
    iconSrc: svgSG,
    iconSrcDark: svgSGDark,
    width: 120,
    height: 80
  },
  {
    type: EKinematicBlockType.DCM,
    title: 'Двигатель постоянного тока',
    iconSrc: svgDCM,
    iconSrcDark: svgDCMDark,
    width: 120,
    height: 80
  },
  {
    type: EKinematicBlockType.DCG,
    title: 'Генератор постоянного тока',
    iconSrc: svgDCG,
    iconSrcDark: svgDCGDark,
    width: 120,
    height: 80
  },
  {
    type: EKinematicBlockType.GB,
    title: 'Одноступенчатая зубчатая передача',
    iconSrc: svgGB,
    iconSrcDark: svgGBDark,
    width: 40,
    height: 160
  },
  {
    type: EKinematicBlockType.GBD,
    title: 'Двухступенчатая зубчатая передача со сменой направления вращения',
    iconSrc: svgGBD,
    iconSrcDark: svgGBDDark,
    width: 40,
    height: 240
  },
  {
    type: EKinematicBlockType.GBT,
    title: 'Двухступенчатая зубчатая передача с разделением момента',
    iconSrc: svgGBT,
    iconSrcDark: svgGBTDark,
    width: 40,
    height: 240
  },
  {
    type: EKinematicBlockType.TGB,
    title: 'Двухходовая двухступенчатая зубчатая передача',
    iconSrc: svgTGB,
    iconSrcDark: svgTGBDark,
    width: 40,
    height: 240
  },
  {
    type: EKinematicBlockType.TW,
    title: 'Рабочее колесо турбины / вентилятора',
    iconSrc: svgTW,
    iconSrcDark: svgTWDark,
    width: 40,
    height: 80
  },
  {
    type: EKinematicBlockType.CW,
    title: 'Рабочее колесо компрессор / насос',
    iconSrc: svgCW,
    iconSrcDark: svgCWDark,
    width: 40,
    height: 80
  },
  {
    type: EKinematicBlockType.TN,
    title: 'Турбина',
    iconSrc: svgTN,
    iconSrcDark: svgTNDark,
    width: 80,
    height: 80
  },
  {
    type: EKinematicBlockType.CN,
    title: 'Компрессор',
    iconSrc: svgCN,
    iconSrcDark: svgCNDark,
    width: 80,
    height: 80
  },
  {
    type: EKinematicBlockType.BD,
    title: 'Ременная передача',
    iconSrc: svgBD,
    iconSrcDark: svgBDDark,
    width: 40,
    height: 160
  },
  {
    type: EKinematicBlockType.CD,
    title: 'Цепная передача',
    iconSrc: svgCD,
    iconSrcDark: svgCDDark,
    width: 40,
    height: 160
  },
  {
    type: EKinematicBlockType.HD,
    title: 'Гидропривод',
    iconSrc: svgHD,
    iconSrcDark: svgHDDark,
    width: 40,
    height: 80
  },
  {
    type: EKinematicBlockType.PD,
    title: 'Пневмо / газовый привод',
    iconSrc: svgPD,
    iconSrcDark: svgPDDark,
    width: 40,
    height: 80
  }
]

export const kbsWithoutIns: Array<EKinematicBlockType> = [
  EKinematicBlockType.AD,
  EKinematicBlockType.SD,
  EKinematicBlockType.DCM,
  EKinematicBlockType.DCG,
  EKinematicBlockType.TN,
  EKinematicBlockType.CN,
  EKinematicBlockType.BF,
  EKinematicBlockType.BS,
  EKinematicBlockType.CP,
  EKinematicBlockType.SH
]

export const kinematicBlockColor = {
  selectedBlock: '#81A0DE',
  parentBlock: '#E9890CFF',
  selectedParentBlock: '#AC650AFF',
  connectedBlock: '#19FF00FF',
  selectedConnectedBlock: '#569c00ff',
  blockWithErrors: '#FF0000FF'
}
